import React from 'react';
import { func } from 'prop-types';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';
import Collapsible from 'react-collapsible';
import { AVAILABLE_LANGUAGES, surveyFieldIds } from '../../../constants';
import TranslatedHTMLText from '../../TranslatedHTMLText';
import { withLang } from '../../../i18n';
import { updateSurveyOptionsAction } from '../../../actions';
import { langType, surveyOptionsType } from '../../../constants/types';
import styles from './researchConsent.module.css';
import FormNavigation from '../FormNavigation';
import { getCompiledPath, getSubRouteForSurveyType } from '../../../util';

const createAccordionTitle = (lang, active, translate) => {
  const activeClassName = active ? 'is-active' : '';

  return (
    <div className={`accordion__title button--accordion theme-transparent ${activeClassName}`}>
      <p className={styles.fontSizeAndNoMargin}>{translate(`inLanguage.${lang}`)}</p>
    </div>
  );
};

const ResearchConsent = ({
  translate, lang: userLang, surveyOptions, dispatchUpdate
}) => {
  const surveyTypeRoute = getSubRouteForSurveyType(surveyOptions.surveyType);

  const userLangIndex = AVAILABLE_LANGUAGES.includes(userLang)
    ? AVAILABLE_LANGUAGES.findIndex((v) => v === userLang) : 0;

  const renderResearchAgreement = () => (
    <ul className="accordion">
      {AVAILABLE_LANGUAGES.map((lang, index) => (
        <li key={lang} className="accordion__item" data-cy={`accordion-item-${lang}`}>
          <Collapsible
            open={index === userLangIndex}
            trigger={createAccordionTitle(lang, false, translate)}
            triggerWhenOpen={createAccordionTitle(lang, true, translate)}
          >
            {/* WARNING: UH-670 - This is not accessible in case the html is not formated correctly */}
            <TranslatedHTMLText html={surveyOptions.researchAgreement} inLanguage={lang} />
          </Collapsible>
        </li>
      ))}
    </ul>
  );

  const onConsentNeededChange = (event) => {
    dispatchUpdate({
      researchConsentNeeded: !event.target.checked
    });
  };

  const prevRoute = surveyOptions.id
    ? getCompiledPath(surveyTypeRoute.survey.edit.participants, { surveyId: surveyOptions.id })
    : surveyTypeRoute.startSurvey.participants;

  return (
    <div>
      <h2 className="panel__title">10. {translate('startSurvey.researchConsent.title')}</h2>
      <div className={styles.checkboxFormItemWithDescription}>
        <input
          type="checkbox"
          id={surveyFieldIds.RESEARCH_CONSENT}
          checked={!surveyOptions.researchConsentNeeded}
          onChange={onConsentNeededChange}
        />
        <label htmlFor={surveyFieldIds.RESEARCH_CONSENT}>
          <Translate id="startSurvey.researchConsent.consentNotNeeded" />
        </label>
        <p className={`form__description ${styles.checkBoxDescription}`}>
          <Translate id="startSurvey.researchConsent.description" />
        </p>
      </div>
      {renderResearchAgreement()}

      <FormNavigation
        canProceed
        previous={prevRoute}
        submit
      />
    </div>
  );
};

ResearchConsent.propTypes = {
  surveyOptions: surveyOptionsType.isRequired,
  dispatchUpdate: func.isRequired,
  ...langType
};

const mapStateToProps = ({ survey, user }) => ({
  surveyOptions: survey.surveyOptions,
  organization: user.currentUser.organization.name
});

const mapDispatchToProps = (dispatch) => ({
  dispatchUpdate: (surveyOptions) => dispatch(updateSurveyOptionsAction(surveyOptions))
});

export default withLang(connect(mapStateToProps, mapDispatchToProps)(ResearchConsent));
